var path = 'templates/transcription/view.html';
var html = "<md-content class=\"viewer vertical-editor\" style=height:100% ng-bind-html=viewHtml> </md-content> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/templates/transcription/view.html
// module id = 69
// module chunks = 0